import { useEffect } from "react";
import { getBrowserScrollbarInfo } from "@/shared/utils/dom";

const CSS_VAR_APP_PADDING_RIGHT = "--app__padding-right";

const setAppPaddingRight = (size) => {
  document.body.style.setProperty(CSS_VAR_APP_PADDING_RIGHT, size);
};

const useLockBodyScroll = (lock) => {
  useEffect(() => {
    let overflowValueInitial, paddingRightValueInitial;

    let isScrollbarTakesContentPlace, scrollBarWidth;
    let isExited = false;

    if (lock) {
      // {setTimeout} is needed, because:
      // Open popup 1 -> locked for popup 1.
      // Open popup 2 without closing popup 1 -> locked for popup 2, unlocked for popup 1.
      setTimeout(() => {
        const elBody = document.body;
        if (isExited || elBody.offsetHeight >= elBody.scrollHeight) {
          return;
        }
        const styleBodyInitial = window.getComputedStyle(elBody);
        overflowValueInitial = styleBodyInitial.overflow;
        paddingRightValueInitial = styleBodyInitial.getPropertyValue(CSS_VAR_APP_PADDING_RIGHT);

        const scrollBarInfo = getBrowserScrollbarInfo();

        isScrollbarTakesContentPlace = scrollBarInfo.isTakesContentPlace;
        scrollBarWidth = scrollBarInfo.width;

        document.body.style.overflow = "hidden";

        if (isScrollbarTakesContentPlace) {
          setAppPaddingRight(scrollBarWidth + "px");
        }
      });
    }

    return () => {
      if (lock) {
        isExited = true;

        document.body.style.overflow = overflowValueInitial;

        if (isScrollbarTakesContentPlace) {
          setAppPaddingRight(paddingRightValueInitial);
        }
      }
    };
  }, [lock]);
};

export default useLockBodyScroll;
